import React from "react";

const Java_Collections = () => {
  return (
    <div>
      <h1>Java Collections</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Collections in Java.</p>
    </div>
  );
};

export default Java_Collections;
